
























































































































































import { Vue, Component } from 'vue-property-decorator';
import Header from '@/components/widgets/organisms/Header/Header.vue';
import Container from '@/components/layouts/Container/Container.vue';
import InputMask from '@/components/widgets/atoms/InputMask/InputMask.vue';
import SingletonHttp from '@/shared/util/api';

@Component({
	components: {
		Header,
		Container,
		InputMask,
	},
})
export default class DeleteAccount extends Vue {
	fullName = '';
	email = '';
	cpf = '';
	message = '';
	confirmDelete = false;
	submitted = false;
	submittedEmail = '';
	isLoading = false;
	emailError = '';
	fullNameError = '';
	cpfError = '';
	messageError = '';
	confirmDeleteError = '';

	validateEmail(email: string): boolean {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	validateCpf(cpf: string): boolean {
		const cleanCpf = cpf.replace(/\D/g, '');

		return cleanCpf.length === 11;
	}

	handleCpfInput(value: string): void {
		this.cpf = value;
		if (this.cpfError) {
			this.cpfError = '';
		}
	}

	handleSubmit(): void {
		this.emailError = '';
		this.fullNameError = '';
		this.cpfError = '';
		this.messageError = '';
		this.confirmDeleteError = '';

		if (!this.fullName || this.fullName.trim() === '') {
			this.fullNameError = 'Por favor, insira seu nome completo';
			return;
		}

		if (!this.email) {
			this.emailError = 'Por favor, insira seu e-mail';
			return;
		}

		if (!this.validateEmail(this.email)) {
			this.emailError = 'Por favor, insira um e-mail válido';
			return;
		}

		if (!this.cpf || this.cpf.trim() === '') {
			this.cpfError = 'Por favor, insira seu CPF';
			return;
		}

		if (!this.validateCpf(this.cpf)) {
			this.cpfError = 'Por favor, insira um CPF válido';
			return;
		}

		if (!this.message || this.message.trim() === '') {
			this.messageError = 'Por favor, insira uma mensagem';
			return;
		}

		if (!this.confirmDelete) {
			this.confirmDeleteError = 'Você deve confirmar que deseja excluir sua conta';
			return;
		}

		this.submitRequest();
	}

	submitRequest(): void {
		this.isLoading = true;

		const http = SingletonHttp.getInstance();
		const cleanCpf = this.cpf.replace(/\D/g, '');

		const requestData = {
			nomeCompleto: this.fullName.trim(),
			email: this.email.trim(),
			cpf: cleanCpf,
			idConta: 0,
			mensagem: this.message.trim(),
		};

		http
			.http({
				method: 'post',
				url: '/SolicitacaoExclusaoConta',
				data: requestData,
				headers: {
					'Content-Type': 'application/json-patch+json',
				},
			})
			.then(() => {
				this.submittedEmail = this.email;
				this.submitted = true;
				this.$toast.success('Solicitação de exclusão enviada com sucesso!');
				window.scrollTo({ top: 0, behavior: 'smooth' });
			})
			.catch((error: any) => {
				const errorMessage =
					error.response?.data?.mensagem ||
					error.response?.data?.message ||
					error.response?.data?.Message ||
					'Erro ao enviar solicitação. Por favor, tente novamente.';
				this.$toast.error(errorMessage);
			})
			.finally(() => {
				this.isLoading = false;
			});
	}

	handleEmailOption(): void {
		const subject = encodeURIComponent('Solicitação de Exclusão de Conta - Uboi 2.0');
		const body = encodeURIComponent(
			`Nome completo: ${this.fullName}\n` +
				`E-mail cadastrado: ${this.email}\n` +
				`CPF: ${this.cpf || 'Não informado'}\n\n` +
				`Mensagem: ${this.message || 'Não informado'}\n\n` +
				`Confirmo que desejo excluir minha conta e compreendo que a ação é irreversível.`,
		);
		window.location.href = `mailto:uboi@jbs.com.br?subject=${subject}&body=${body}`;
	}

	resetForm(): void {
		this.fullName = '';
		this.email = '';
		this.cpf = '';
		this.message = '';
		this.confirmDelete = false;
		this.submitted = false;
		this.submittedEmail = '';
		this.isLoading = false;
		this.emailError = '';
		this.fullNameError = '';
		this.cpfError = '';
		this.messageError = '';
		this.confirmDeleteError = '';
	}
}
